import { getPropertiesSearchParams } from '@/components/Dashboard/DashboardPendings/utils';

export const getHeaderUrl = (operationId, statusId, selectedIds) => {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const searchParams = getPropertiesSearchParams({
    operation_types: [operationId],
    statusId,
    selectedIds,
  });

  return `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
};

export const handleClickBar = (
  operationId,
  statusId,
  ageMin,
  ageMax,
  selectedIds
) => {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const searchParams = getPropertiesSearchParams({
    operation_types: [operationId],
    statusId,
    ageMin,
    ageMax,
    selectedIds,
  });

  const url = `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
  window.open(url, '_blank');
};
